import NumberField from './Number';

export default NumberField;
